import { ArcElement, Chart as ChartJS, ChartData, Legend, Tooltip, TooltipItem } from 'chart.js'
import { Doughnut } from 'react-chartjs-2'

ChartJS.register(ArcElement, Tooltip, Legend)

const getOptions = (size: 's' | 'l', customLabel?: string) => ({
  cutout: size === 'l' ? '60%' : '40%',
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      enabled: size === 'l',
      backgroundColor: '#fff',
      displayColors: false,
      bodyColor: '#000',
      callbacks: {
        label: function (context: TooltipItem<'doughnut'>) {
          const label = customLabel || 'task'
          const parsed = context.parsed
          return `${parsed} ${parsed === 1 ? label : `${label}s`}`
        },
      },
    },
  },
})

export function DoughnutChart({
  data,
  customLabel,
  size = 'l',
}: Readonly<{
  data: ChartData<'doughnut'>
  customLabel?: string
  size?: 's' | 'l'
}>) {
  return <Doughnut data-testid='doughnut-chart' data={data} options={getOptions(size, customLabel)} />
}
